import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/react-hooks";
import { EDIT_NOTIFICATION_SETTING } from "../../mutation/editNotificationSetting";
import { hasuraClient } from "../../apolloClient";
import { Spinner } from "react-bootstrap";
import { GET_NOTIFICATION_SETTING } from "../../query/getNotificationSetting";

const Notification = () => {
  const [editNotificationSetting] = useMutation(EDIT_NOTIFICATION_SETTING, {
    client: hasuraClient,
  });

  const [activityEvent, setEventActivity] = useState(false);
  const [activityBusiness, setActivityBusiness] = useState(false);
  const [activityDeals, setActivityDeals] = useState(false);
  const [message, setMessage] = useState(false);
  const [businessUpdate, setBusinessUpdate] = useState(false);
  const [emailNotification, setEmailNotification] = useState(false);
  const [activityEventEmail, setActivityEventEmail] = useState(false);
  const [activityDealsEmail, setActivityDealsEmail] = useState(false);
  const [messageEmail, setMessageEmail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isNew, setIsNew] = useState(true);

  const { data: notiData, loading: notiLoading } = useQuery(
    GET_NOTIFICATION_SETTING,
    {
      client: hasuraClient,
      fetchPolicy: "cache-and-network",
      variables: {
        user_id: localStorage.getItem("user_id"),
      },
    }
  );

  const handleSubmit = () => {
    setLoading(true);

    editNotificationSetting({
      variables: {
        data: {
          activity_on_business_page: activityBusiness,
          activity_on_deals: activityDeals,
          activity_on_events: activityEvent,
          messages: message,
          email_notifications: emailNotification,
          email_activity_on_attractions: true,
          email_activity_on_deals: activityDealsEmail,
          email_activity_on_events: activityEventEmail,
          email_message: messageEmail,
          business_updates: businessUpdate,
        },
        user_id: localStorage.getItem("user_id"),
      },
    })
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (notiData && !notiLoading) {
      setEventActivity(notiData.notification_settings[0].activity_on_events);
      setActivityBusiness(
        notiData.notification_settings[0].activity_on_business_page
      );
      setActivityDeals(notiData.notification_settings[0].activity_on_deals);
      setMessage(notiData.notification_settings[0].messages);
      setBusinessUpdate(notiData.notification_settings[0].business_updates);
      setEmailNotification(
        notiData.notification_settings[0].email_notifications
      );
      setActivityEventEmail(
        notiData.notification_settings[0].email_activity_on_events
      );
      setActivityDealsEmail(
        notiData.notification_settings[0].email_activity_on_deals
      );
      setMessageEmail(notiData.notification_settings[0].email_message);
    }
  }, [notiData, notiLoading]);

  useEffect(() => {
    if (emailNotification && !isNew) {
      setMessageEmail(true);
      setActivityDealsEmail(true);
      setActivityEventEmail(true);
    } else if (!isNew) {
      setMessageEmail(false);
      setActivityDealsEmail(false);
      setActivityEventEmail(false);
    }
  }, [emailNotification]);

  return (
    <div className="notications-cover">
      <div className="setting-title">
        <h2>General</h2>
        <p>Manage your desktop notifications.</p>
      </div>
      <div className="preference-block">
        <label>Your preferences</label>
        <ul>
          <li>
            <label class="switch">
              <input
                type="checkbox"
                onChange={(e) => {
                  setIsNew(false);
                  setEventActivity(e.target.checked);
                }}
                checked={activityEvent}
              />
              <span class="slider"></span>
            </label>
            <div className="content">
              <h3>Activity on Events</h3>
              <p>
                Notify me about ticket purchases and other activites on
                published Events
              </p>
            </div>
          </li>
          <li>
            <label class="switch">
              <input
                type="checkbox"
                onChange={(e) => {
                  setIsNew(false);
                  setActivityBusiness(e.target.checked);
                }}
                checked={activityBusiness}
              />
              <span class="slider"></span>
            </label>
            <div className="content">
              <h3>Activity on Business page</h3>
              <p>
                Notify me about reviews, posts and other activities on my
                business page
              </p>
            </div>
          </li>
          <li>
            <label class="switch">
              <input
                type="checkbox"
                onChange={(e) => {
                  setIsNew(false);
                  setActivityDeals(e.target.checked);
                }}
                checked={activityDeals}
              />
              <span class="slider"></span>
            </label>
            <div className="content">
              <h3>Activity on Deals</h3>
              <p>Notify me about activites on published Deals</p>
            </div>
          </li>
          <li>
            <label class="switch">
              <input
                type="checkbox"
                onChange={(e) => {
                  setIsNew(false);
                  setMessage(e.target.checked);
                }}
                checked={message}
              />
              <span class="slider"></span>
            </label>
            <div className="content">
              <h3>Messages</h3>
              <p>Notify me when others send me a direct message</p>
            </div>
          </li>
          <li>
            <label class="switch">
              <input
                type="checkbox"
                onChange={(e) => {
                  setIsNew(false);
                  setBusinessUpdate(e.target.checked);
                }}
                checked={businessUpdate}
              />
              <span class="slider"></span>
            </label>
            <div className="content">
              <h3>Business Updates</h3>
              <p>
                Notify me about profile updates, new terms and condition and
                other Business activities
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div className="setting-title">
        <h2>Email Notifications</h2>
        <p>
          These notifications are sent to {localStorage.getItem("user_mail")}
        </p>
      </div>
      <div className="preference-block">
        <label>Email notifications</label>
        <ul>
          <li>
            <label class="switch">
              <input
                type="checkbox"
                onChange={(e) => {
                  setIsNew(false);
                  setEmailNotification(e.target.checked);
                }}
                checked={emailNotification}
              />
              <span class="slider"></span>
            </label>
            <div className="content">
              <h3>Get notified on your email</h3>
            </div>
          </li>
        </ul>
      </div>
      <div className="preference-block">
        <label>Your preferences</label>
        <ul>
          <li>
            <label class="switch">
              <input
                type="checkbox"
                onChange={(e) => {
                  setIsNew(false);
                  setActivityEventEmail(e.target.checked);
                }}
                checked={
                  emailNotification ? activityEventEmail : emailNotification
                }
              />
              <span class="slider disable"></span>
            </label>
            <div className="content">
              <h3>Activity on Events</h3>
              <p>
                Notify me about ticket purchases and other activites on
                published Events
              </p>
            </div>
          </li>
          <li>
            <label class="switch">
              <input
                type="checkbox"
                onChange={(e) => {
                  setIsNew(false);
                  setActivityDealsEmail(e.target.checked);
                }}
                checked={
                  emailNotification ? activityDealsEmail : emailNotification
                }
              />
              <span class="slider disable"></span>
            </label>
            <div className="content">
              <h3>Activity on Deals</h3>
              <p>Notify me about activites on published Deals</p>
            </div>
          </li>
          <li>
            <label class="switch">
              <input
                type="checkbox"
                onChange={(e) => {
                  setIsNew(false);
                  setMessageEmail(e.target.checked);
                }}
                checked={emailNotification ? messageEmail : emailNotification}
              />
              <span class="slider disable"></span>
            </label>
            <div className="content">
              <h3>Message</h3>
              <p>Notify me when others send me a direct message</p>
            </div>
          </li>
        </ul>
      </div>
      <div className="Save-btn">
        <button
          className="primary-button"
          onClick={() => {
            handleSubmit();
          }}
        >
          {loading ? (
            <Spinner
              className="spinner"
              animation="border"
              role="status"
              style={{ height: "20px", width: "20px" }}
            >
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          ) : (
            "Save"
          )}
        </button>
      </div>
    </div>
  );
};

export default Notification;
